/**
 * @generated SignedSource<<3c877e6700bc5fca77176db14fe44a2d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SourceAdminMenuGenMutation$variables = {
  id: string;
};
export type SourceAdminMenuGenMutation$data = {
  readonly generateSourceToLangs: {
    readonly copySource: boolean | null;
  } | null;
};
export type SourceAdminMenuGenMutation = {
  response: SourceAdminMenuGenMutation$data;
  variables: SourceAdminMenuGenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "copySource",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SourceAdminMenuGenMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Source",
        "kind": "LinkedField",
        "name": "generateSourceToLangs",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SourceAdminMenuGenMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Source",
        "kind": "LinkedField",
        "name": "generateSourceToLangs",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e235e98ba2759505f2e34498bf6c12c5",
    "id": null,
    "metadata": {},
    "name": "SourceAdminMenuGenMutation",
    "operationKind": "mutation",
    "text": "mutation SourceAdminMenuGenMutation(\n  $id: ID!\n) {\n  generateSourceToLangs(id: $id) {\n    copySource\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "6c07042f7a5f6e0b3d8797489a13d8d3";

export default node;
